import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../helpers/useAuth';
import { SessionNavToolbar } from '../components/SessionNavToolbar';
import { FaqPage } from '../components/FaqPage';
import styles from './faq.module.css';

export default function Faq() {
  const [panelSide, setPanelSide] = useState<'left' | 'right'>('right');
  const { authState } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const saved = localStorage.getItem('tasking_panel_side') as 'left' | 'right' | null;
    if (saved) setPanelSide(saved);
  }, []);

  const navSide = panelSide === 'right' ? 'left' : 'right';
  const isAuthenticated = authState.type === 'authenticated';

  return (
    <>
      <title>Documentation | Tasking.tech</title>
      <div className={styles.pageShell}>
        {isAuthenticated ? (
          <>
            {navSide === 'left' && <SessionNavToolbar side="left" />}
            <div className={styles.mainColumn}>
              <FaqPage />
            </div>
            {navSide === 'right' && <SessionNavToolbar side="right" />}
          </>
        ) : (
          <>
            <div className={styles.mainColumn}>
              <nav className="border-b border-border/50 px-6 py-4 flex items-center justify-between">
                <a href="/" className="tasking-wordmark text-lg font-semibold">
                  tasking<span className="text-primary">.tech</span>
                </a>
                <button
                  onClick={() => navigate('/login')}
                  className="rounded-lg border border-border bg-secondary px-4 py-2 text-sm font-medium text-foreground transition-colors hover:border-primary/30"
                >
                  Log in
                </button>
              </nav>
              <FaqPage />
            </div>
          </>
        )}
      </div>
    </>
  );
}
